if (!customElements.get('theme-localization')) {
  class ThemeLocalization extends HTMLElement {
    constructor() {
      super();
      this.handleOptionClick = this.handleOptionClick.bind(this);
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('click', this.handleOptionClick, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleOptionClick(event) {
      const option = event.target.closest('[role="option"]');
      if (!option) return;

      option.closest('form')?.submit();
    }
  }

  customElements.define('theme-localization', ThemeLocalization);
}
